import React, { useState, useEffect, useCallback, useMemo } from "react";
import Button from "../button/button";
import CookieImage from "/src/assets/images/cookie.svg";
import Cookies from "universal-cookie";

const COOKIE_NAME = "user_consent";

const CookieBanner = () => {
  const [cookies, setCookies] = useState([]);
  const [decisionMade, setDecisionMade] = useState(true);
  const cookieInstance = useMemo(() => new Cookies(), []);

  function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  const sendConsent = useCallback((consent) => {
    gtag('consent', 'update', consent);
  }, []);

  useEffect(() => {
    const consentCookie = cookieInstance.get(COOKIE_NAME);
    if (consentCookie !== undefined) {
      setDecisionMade(true);
    } else {
      setDecisionMade(false);
    }
  }, [cookieInstance]);

  const handleDecision = (outcome) => {
    const consent = {
      'ad_storage': outcome,
      'analytics_storage': outcome,
      'ad_user_data': outcome,
      'ad_personalization': outcome,
      'functionality_storage': outcome,
      'personalization_storage': outcome,
      'security_storage': outcome
    };

    cookieInstance.set(COOKIE_NAME, consent, {
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
      path: "/",
      domain: window.location.hostname
    });

    sendConsent(consent);
    setDecisionMade(true);
  };

  const handleBounce = (event) => {
    const { clientX, clientY } = event;
    const newCookie = { x: clientX, y: clientY, id: Date.now() };

    setCookies((prevCookies) => [...prevCookies, newCookie]);

    setTimeout(() => {
      setCookies((prevCookies) => prevCookies.filter(cookie => cookie.id !== newCookie.id));
    }, 1000);
  };

  if (decisionMade) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <p className="cookie-banner-content">
        our website uses <span onClick={handleBounce}>cookies</span> to give you the best possible experience.
      </p>
      {cookies && cookies.map((cookie) => (
        <img
          key={cookie.id}
          src={CookieImage}
          className="cookie-image bounce"
          style={{
            left: `${cookie.x}px`,
            top: `${cookie.y}px`,
            position: "fixed",
            transform: "translate(-50%, -50%)",
          }}
        />
      ))}
      <div className="cookie-banner-button-container">
        <Button
          title={"Decline"}
          children={"Decline"}
          type={"decline"}
          isButton={true}
          onClick={() => handleDecision("denied")}
        />
        <Button
          title={"Accept"}
          children={"Accept"}
          type={"accept"}
          isButton={true}
          onClick={() => handleDecision("granted")}
        />
      </div>
    </div>
  );
}

export default CookieBanner;
